var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement}},[_c('el-icon',{attrs:{"name":"question"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }